var React = require('react');

function ShareFacebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0H24V24H0z","key":0}),React.createElement("g",{"fillRule":"nonzero","key":1},[React.createElement("path",{"fill":"#39579A","d":"M23 24c.552 0 1-.448 1-1V1c0-.552-.448-1-1-1H1C.448 0 0 .448 0 1v22c0 .552.448 1 1 1h22z","key":0}),React.createElement("path",{"fill":"#FFF","d":"M12.76 24v-9.5H9.5V11h3.26V8.413c0-3.1 1.893-4.788 4.658-4.788 1.325 0 2.463.098 2.795.143v3.24h-1.918c-1.504 0-1.795.715-1.795 1.763V11H20l-.5 3.5h-3V24h-3.74z","key":1})])]));
}

ShareFacebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ShareFacebook;

ShareFacebook.default = ShareFacebook;
